export enum Intervals {
  WEEKLY = 1604800017,
  DAILY = 86400000,
  HOURLY = 3600000,
}
